import React, { Component } from "react";

export default class Faq extends Component {
  render() {
    const { header, body } = this.props;

    return (
      <div style={{ margin: 10 }}>
        <details>
          <summary className="nps-faq-header">{header}</summary>
          <div className="nps-faq-body">
            <p style={{ whiteSpace: "pre-line", verticalAlign: "bottom" }}>
              {body}
            </p>
          </div>
        </details>
      </div>
    );
  }
}
